import {api} from '@/api/factory';

class Genres {
    constructor() {}

    get() {
        return api.get('/v1/publisher/videos/genres');
    }
}

export default Genres